module.exports = __webpack_public_path__ + "static/img/iberica-logo.11fd757.svg";